import axios from "axios";

import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const testAlert = (id) => dispatch => axios.get(`${apiUrl}generate-alert/${id}`);

export const testTest = () => {};



// WEBPACK FOOTER //
// ./src/actions/test/actions.js